import { intl } from '@approvalmax/utils';
import { domain } from 'modules/data';
import { ColumnDefinition } from 'pages/requestList/selectors/types/ColumnDefinition';

import { messages } from './QBooksJournalEntryLines.messages';

export const getColumnDefinition = (currency: string): ColumnDefinition<domain.QBooksJournalEntryLine>[] => [
    {
        id: 'number',
        name: messages.numberColName,
        value: (_li, lineIndex) => String(lineIndex + 1),
    },
    {
        id: 'account',
        name: messages.accountColName,
        value: (li) => li.account?.text ?? null,
    },
    {
        id: 'debit',
        name: `${messages.debitColName} (${currency})`,
        alignRight: true,
        value: (li) =>
            li.amountType === domain.QBooksJournalEntryLineAmountType.Debit && typeof li.amount === 'number'
                ? intl.formatNumber(li.amount, 'auto')
                : null,
    },
    {
        id: 'credit',
        name: `${messages.creditColName} (${currency})`,
        alignRight: true,
        value: (li) =>
            li.amountType === domain.QBooksJournalEntryLineAmountType.Credit && typeof li.amount === 'number'
                ? intl.formatNumber(li.amount, 'auto')
                : null,
    },
    {
        id: 'description',
        name: messages.descriptionColName,
        value: (li) => li.description,
    },
    {
        id: 'payeeType',
        name: messages.payeeTypeColName,
        value: (li) => li.payeeType?.text ?? null,
    },
    {
        id: 'name',
        name: messages.payeeColName,
        value: (li) => li.payee?.text ?? null,
    },
    {
        id: 'taxCode',
        name: messages.taxCodeColName,
        value: (li) => li.taxCode?.text ?? null,
    },
    {
        id: 'department',
        name: messages.departmentColName,
        value: (li) => li.department?.text ?? null,
    },
    {
        id: 'class',
        name: messages.classColName,
        value: (li) => li.class?.text ?? null,
    },
];
